import { fixIssuesBannerBgUrl } from '@/assets/images';
import { StyledAdjustableRow } from '@/shared/styles';
import { isMobileOnly } from 'react-device-detect';
import styled from 'styled-components';

export const StyledFixIssuesBanner = styled(StyledAdjustableRow)`
  background: url(${fixIssuesBannerBgUrl});
  background-repeat: no-repeat;
  background-size: cover;
  border: 1px solid ${(props) => props.theme.marginsColor};
  border-radius: 5px;
  color: ${(props) => props.theme.textColor};
  gap: 24px;
  justify-content: center;

  ${isMobileOnly
    ? `
    padding: 24px;
    align-items: start;
    `
    : `
    height: 98px;
    width: 100%;
    align-items: center;
    `}
`;

export const StyledScoreSeparator = styled.hr`
  width: 100%;
  border: none;
  background-color: ${(props) => props.theme.marginsColor};
  margin: 0px;
  height: 2px;
`;
